import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Spinner } from '../components/Spinner';

// UI-side gate only. The real enforcement is requireAdmin in every admin
// function (CLAUDE.md §2.4) — hiding admin UI is never the sole protection.
export function RequireAdmin() {
  const { role, loading, firebaseUser } = useAuthStore();
  if (loading) return <Spinner full />;
  if (!firebaseUser) return <Navigate to="/login" replace />;
  if (role !== 'admin') return <Navigate to="/" replace />;
  return <Outlet />;
}
